import { Link } from 'react-router-dom'
import PageSeo from '../components/PageSeo'

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center">
      <PageSeo title="Az oldal nem található" noindex={true} />

      <p className="font-display text-8xl font-bold text-gold/20 mb-4 select-none">404</p>

      <h1 className="font-display text-3xl sm:text-4xl text-heading mb-4">
        Ez az oldal nem található
      </h1>
      <p className="text-muted-text text-base leading-relaxed max-w-md mb-10">
        A keresett oldal nem létezik vagy áthelyezték.
        Vissza a főoldalra, onnan minden elérhető.
      </p>

      <div className="flex flex-wrap gap-3 justify-center">
        <Link
          to="/"
          className="px-7 py-3 rounded-xl font-bold text-sm text-ink transition-all hover:-translate-y-0.5"
          style={{ background: 'linear-gradient(90deg,#C9A84C,#F5EDD0)', boxShadow: '0 6px 24px rgba(201,168,76,0.25)' }}
        >
          Főoldal
        </Link>
        <Link
          to="/kapcsolat"
          className="px-7 py-3 rounded-xl font-bold text-sm border border-border/10 text-muted-text hover:text-heading hover:border-gold/30 transition-all"
        >
          Kapcsolat
        </Link>
      </div>
    </div>
  )
}
